import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { DropzoneArea } from 'mui-file-dropzone';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { GridComponent } from 'src/components/common/GridComponent';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { sendRequest } from 'src/hooks/useFetch';
import { hideLoader, setProgress, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { IDocumentArtifactInfo, INewISFDocument, IUploadedDocumentISF } from 'src/types/UploadedDocumentISF';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import './DocumentUpload.scss';
import { useDocumentUploads } from './useDocumentUploads';

interface stateDocs {
  documentMetaData?: any;
  openUploadDocument?: boolean;
  setDocumentMetaData?: any;
  updatedDocsList?: any;
  setUpdatedDocsList?: any;
  docsChipList?: any[];
  clearData?: any;
  error?: string | null;
  documentsHoldingObject?: any;
  selectedTrainingLogId?: string;
  setOpenUploadDocument?: any;
  uploadDataFile?: any;
  uploadDocPermission?: boolean;
  deleteDocPopup?: boolean;
  handleDocDeleteconfirm?: any;
  handleDocDeletePopupClose?: any;
  isUploadedDocExisted?: boolean;
  setIsUploadOnExisted?: any;
  originallyAssociated1572Document?: any;
}

export const Form1572DocUpload = (props: stateDocs) => {
  const [isUpload, setIsUpload] = useState<boolean>(false);
  const [enable, setEnable] = useState<boolean>(false);
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const dispatchApp = useAppDispatch();
  const {
    getISFDocInfoByLevelTypeArtifactNameDataQuery,
    createMasterDocumentIsf,
    getIsfDocDetailsByStudyDocIdQuerry,
    updateInlineMasteDocIsfQuerry
  } = useDocumentUploads();
  const [dfile, setDfile] = useState<any>(null);
  const [styleUpload, setStyleUpload] = useState('uploadFile');
  const error = null;
  const [docName, setDocName] = useState<string>('');
  const [includesPHICheck, setIncludesPHICheck] = useState<boolean>(false);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [fileUploadData, setFileUploadData] = useState<IUploadedDocumentISF>({
    isf_prefix: '',
    isf_raw_file_name: '',
    isf_bucket_name: '',
    isf_hashed_file_name: '',
    isf_doc_version_number: 0,
    isf_doc_size: '',
    isf_doc_type: '',
    isf_doc_viewer_pages: '',
    id: '',
    is_active: false,
    isf_doc_created_by: '',
    isf_doc_upload_date: '',
    created_on: '',
    updated_on: ''
  });
  const [artifactInfo, setArtifactInfo] = useState<IDocumentArtifactInfo>({
    isf_artifact_number: '',
    isf_artifact_name: '',
    isf_doc_type: '',
    isf_doc_subtype: '',
    isf_doc_milestone: ''
  });

  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg } = useFieldTranslation();

  const studyId: string | null = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry: string | null = useAppSelector(state => state.site.selectedCountry);
  const selectedSite: string | null = useAppSelector(state => state.site.selectedSite);

  const useStyles = makeStyles(() =>
    createStyles({
      previewChip: {
        minWidth: 160,
        maxWidth: 210
      }
    })
  );

  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    if (isUpload) {
      if (error) {
        setStyleUpload('uploadFileError');
      } else {
        setStyleUpload('uploadFileSuccess');
      }
    } else {
      setStyleUpload('uploadFile');
    }
  }, [isUpload, error]);
  const handleRejectedMessage = (rejectedFile: any, acceptedFiles: any, maxFileSize: any) => {
    let message = `${rejectedFile.name} cannot be uploaded! , `;
    const arrFile = rejectedFile.name.split('.');
    if (!acceptedFiles.includes(`.${arrFile[arrFile.length - 1]}`)) {
      message += `File Format is not supported`;
    } else if (rejectedFile.size > maxFileSize) {
      message += `File Size more than 5MB is not allowed.`;
    }
    //setError(message);
    return message;
  };

  const handleUploadDocument = async () => {
    const check = await uploadDataFile();
    if (!check) {
      return;
    }
    if (docName !== '') {
      try {
        let response: any;
        dispatch(showLoader());
        setDisableSubmit(true);
        if (props.isUploadedDocExisted) {
          if (!props.updatedDocsList[0].is_uploaded) {
            const newDocObj = getCreatedNewMasterDocument(check);
            const result: any = await createMasterDocumentIsf({
              data: newDocObj,
              study_id: studyId,
              country: selectedCountry,
              site_id: selectedSite,
              application: process.env.REACT_APP_NAME,
              audit_module_section: 'STUDY LOGS',
              parent_entity_related: ''
            });
            response = result?.data;
          } else {
            const result: any = await getIsfDocDetailsByStudyDocIdQuerry({
              study_id: studyId,
              site_id: selectedSite,
              country: selectedCountry,
              documentId: props.updatedDocsList[0].document_id,
              application: process.env.REACT_APP_NAME,
              module_section_related: 'STUDY LOGS',
              parent_entity_related: ''
            });
            const docToBeOverwritten: any = result?.data;
            const overwritingObj = {
              file_master_id: fileUploadData.id,
              document_data: {
                isf_artifact_number: docToBeOverwritten.document_data.isf_artifact_number,
                isf_document_name: docName,
                isf_doc_type: docToBeOverwritten.document_data.isf_doc_type,
                isf_doc_subtype: docToBeOverwritten.document_data.isf_doc_subtype,
                isf_doc_viewer_includes_phi: includesPHICheck,
                isf_doc_viewer_red_certified_copy: docToBeOverwritten.document_data.isf_doc_viewer_red_certified_copy,
                isf_doc_status: docToBeOverwritten.document_data.isf_doc_status,
                isf_doc_country: docToBeOverwritten.document_data.isf_doc_country,
                isf_doc_study: docToBeOverwritten.document_data.isf_doc_study,
                isf_doc_site: docToBeOverwritten.document_data.isf_doc_site,
                isf_doc_viewer_department: docToBeOverwritten.document_data.isf_doc_viewer_department,
                isf_doc_viewer_language: docToBeOverwritten.document_data.tmf_doc_viewer_language,
                isf_doc_viewer_approval_cycle: docToBeOverwritten.document_data.isf_doc_viewer_approval_cycle,
                isf_doc_viewer_product_detail: docToBeOverwritten.document_data.isf_doc_viewer_product_detail,
                isf_doc_viewer_ref_model_version: docToBeOverwritten.document_data.isf_doc_viewer_ref_model_version,
                isf_doc_viewer_format: docToBeOverwritten.document_data.isf_doc_viewer_format,
                isf_doc_viewer_inspection_ready: docToBeOverwritten.document_data.tmf_doc_viewer_inspection_ready,
                isf_doc_viewer_ir_issue_type: docToBeOverwritten.document_data.isf_doc_viewer_ir_issue_type,
                isf_doc_level: docToBeOverwritten.document_data.isf_doc_level,
                isf_artifact_name: artifactInfo.isf_artifact_name,
                isf_doc_version_number: fileUploadData.isf_doc_version_number,
                isf_doc_milestone: artifactInfo.isf_doc_milestone,
                isf_document_id: docToBeOverwritten.document_data.isf_document_id,
                isf_doc_viewer_doc_phi_redacted: docToBeOverwritten.document_data.isf_doc_viewer_doc_phi_redacted,
                id: docToBeOverwritten.document_data.id,
                isf_doc_viewer_last_modified_by: fileUploadData.isf_doc_created_by
              }
            };
            const result1: any = await updateInlineMasteDocIsfQuerry({
              data: overwritingObj,
              study_id: studyId,
              country: selectedCountry,
              site_id: selectedSite,
              application: process.env.REACT_APP_NAME,
              module_section_related: 'STUDY LOGS',
              parent_entity_related: docName
            });
            response = result1?.data;
          }
        } else {
          const newDocObj = getCreatedNewMasterDocument(check);
          const result: any = await createMasterDocumentIsf({
            data: newDocObj,
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'STUDY LOGS',
            parent_entity_related: ''
          });
          response = result?.data;
        }
        dispatch(hideLoader());
        props.setOpenUploadDocument(false);
        if (response) {
          props.uploadDataFile(response);
          dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
        }
      } catch (error: any) {
        dispatch(hideLoader());
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
    } else {
      dispatch(setProgress(false));
      dispatchApp(setMessage({ msgDetails: 'Document name is missing', severity: 'error' }));
    }
  };
  const getCreatedNewMasterDocument = (data: any) => {
    const isfUploadDocObj: INewISFDocument = {
      file_master_id: data.id,
      document_data: {
        isf_artifact_number: artifactInfo.isf_artifact_number,
        isf_document_name: docName,
        isf_doc_type: artifactInfo.isf_doc_type,
        isf_doc_subtype: artifactInfo.isf_doc_subtype,
        isf_doc_viewer_includes_phi: includesPHICheck,
        isf_doc_viewer_red_certified_copy: 'N',
        isf_doc_status: 'Uploaded',
        isf_doc_country: selectedCountry,
        isf_doc_study: studyId,
        isf_doc_site: selectedSite,
        isf_doc_viewer_department: 'None',
        isf_doc_viewer_language: 'English',
        isf_doc_viewer_approval_cycle: 0,
        isf_doc_viewer_product_detail: 'test1',
        isf_doc_viewer_ref_model_version: 'ISF RM v1.0',
        isf_doc_viewer_format: 'PDF',
        isf_doc_viewer_inspection_ready: '',
        isf_doc_viewer_ir_issue_type: '',
        isf_doc_level: 'Site',
        isf_artifact_name: artifactInfo.isf_artifact_name,
        isf_doc_version_number: data.isf_doc_version_number,
        isf_doc_milestone: artifactInfo.isf_doc_milestone,
        isf_document_id: 'str',
        isf_doc_viewer_doc_phi_redacted: 'N',
        isf_doc_viewer_created_by: data.isf_doc_created_by
      }
    };
    return isfUploadDocObj;
  };

  const isSubmitDisabled = () => {
    return disableSubmit;
  };

  const handleDocumentName = (e: any) => {
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    setDocName(formattedVal);
  };
  const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncludesPHICheck(event.target.checked);
  };
  const handleDialogBoxOpen = () => {
    setEnable(true);
  };
  const handleDialogBoxClose = () => {
    setEnable(false);
  };
  const getISFDocInfo = async (artifactName: string | undefined) => {
    try {
      dispatch(showLoader());
      const docResult: any = await getISFDocInfoByLevelTypeArtifactNameDataQuery({
        level_type: 'Site',
        artifactName,
        study_id: studyId,
        country: selectedCountry,
        site_id: selectedSite,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });
      setArtifactInfo({
        ...docResult?.data,
        isf_artifact_name: props.documentMetaData?.name
      });
      dispatch(hideLoader());
    } catch (error: any) {
      dispatch(hideLoader());
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: 'Error while getting document info', severity: 'error' }));
      }
    }
  };
  const getDocVersion = (): string | number => {
    return fileUploadData.isf_doc_version_number === 0 ? '' : fileUploadData.isf_doc_version_number.toFixed(1);
  };
  const uploadFile = async (file: any): Promise<IUploadedDocumentISF> => {
    try {
      dispatch(showLoader());
      const formData = new FormData();
      formData.append('file', file);
      const options = {
        endPointEnv: 'isf',
        data: formData,
        pathVariables: {
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          appName: process.env.REACT_APP_NAME,
          module_section_related: 'STUDY LOGS',
          parent_entity_related: ''
        }
      };
      const response: any = await sendRequest('isf_file_master_upload_file', options);
      dispatch(hideLoader());
      return response;
    } catch {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      return Promise.reject();
    }
  };
  const uploadDataFile = async (): Promise<any> => {
    if (dfile) {
      const result = await uploadFile(dfile);
      if (result) {
        setFileUploadData(result);
        return result;
      } else {
        return false;
      }
    }
  };
  useEffect(() => {
    if (dfile) {
      setIsUpload(true);
    } else {
      setIsUpload(false);
    }
  }, [dfile]);
  useEffect(() => {
    if (props.openUploadDocument) {
      getISFDocInfo(props.documentMetaData?.name);
    }
  }, [props.openUploadDocument]);

  return (
    <div className="document-upload-page">
      <div className="card">
        <Grid container spacing={3}>
          <Loader />
          <Grid item md={12}>
            <div id="uploadFile" className={styleUpload}>
              <DropzoneArea
                fileObjects={[]}
                showPreviewsInDropzone={isUpload}
                filesLimit={1}
                maxFileSize={5000000}
                acceptedFiles={[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ]}
                useChipsForPreview
                showFileNames={false}
                dropzoneText={
                  isUpload ? 'Your file upload has been successfully initiated' : `Drag and drop your file here or`
                }
                previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                previewChipProps={{ classes: { root: classes.previewChip } }}
                previewText="Selected files"
                onChange={e => {
                  if (e.length > 0) {
                    setIsUpload(true);
                    setDfile(e[0]);
                  }
                }}
                getFileLimitExceedMessage={(_: number) =>
                  'You cannot upload more than one file at once. Please try with single file'
                }
                getDropRejectMessage={handleRejectedMessage}
              />
              <Typography
                variant="body2"
                display="block"
                gutterBottom
                color="text.secondary"
                sx={{ mt: -4, textAlign: 'center', position: 'relative', zIndex: 12 }}
              >
                <strong>Accepted file type:&nbsp;</strong>
                {[
                  '.jpg',
                  '.jpeg',
                  '.gif',
                  '.png',
                  '.bmp',
                  '.tif',
                  '.tiff',
                  '.psd',
                  '.pdf',
                  '.doc',
                  '.docx',
                  '.xls',
                  '.xlsx'
                ].toString()}
              </Typography>
            </div>
          </Grid>
          <Grid item md={12}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled={!isUpload}
                    required
                    id="standard-select-currency-native"
                    label="Document Name "
                    variant="standard"
                    value={docName}
                    inputProps={{
                      maxLength: 200
                    }}
                    onChange={e => handleDocumentName(e)}
                  />
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Version Number"
                    variant="standard"
                    value={getDocVersion()}
                  >
                    <MenuItem value={getDocVersion()}>{getDocVersion()}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    required
                    label="Artifact Number"
                    variant="standard"
                    value={artifactInfo.isf_artifact_number}
                  >
                    <MenuItem value={artifactInfo.isf_artifact_number}>{artifactInfo.isf_artifact_number}</MenuItem>
                  </TextField>
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    required
                    label="Artifact Name"
                    variant="standard"
                    value={artifactInfo.isf_artifact_name}
                  >
                    <MenuItem value={artifactInfo.isf_artifact_name}>{artifactInfo.isf_artifact_name}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Type"
                    variant="standard"
                    value={artifactInfo.isf_doc_type}
                  >
                    <MenuItem value={artifactInfo.isf_doc_type}>{artifactInfo.isf_doc_type}</MenuItem>
                  </TextField>
                </FormControl>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    label="Upload Date"
                    placeholder={userPreferedDateFormat.toLowerCase()}
                    variant="standard"
                    type={isUpload ? 'text' : ''}
                    value={isUpload ? preferedDateFormat(fileUploadData.created_on.slice(0, 10)) : ''}
                  />
                </FormControl>
              </Grid>
              <Grid item md={4}>
                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-required"
                    select
                    label="Milestone"
                    value={artifactInfo.isf_doc_milestone}
                    variant="standard"
                    InputProps={{
                      readOnly: true
                    }}
                  >
                    <MenuItem value={artifactInfo.isf_doc_milestone}>{artifactInfo.isf_doc_milestone}</MenuItem>
                  </TextField>
                </FormControl>

                <FormControl fullWidth margin="normal">
                  <TextField
                    disabled
                    id="standard-select-currency-native"
                    select
                    label="Subtype"
                    variant="standard"
                    value={artifactInfo.isf_doc_subtype}
                  >
                    <MenuItem value={artifactInfo.isf_doc_subtype}>{artifactInfo.isf_doc_subtype}</MenuItem>
                  </TextField>
                </FormControl>
                <FormControlLabel
                  control={<Checkbox disabled={!isUpload} checked={includesPHICheck} onChange={handleCheckBox} />}
                  label="Includes PHI?"
                />
              </Grid>
            </Grid>
            {props.docsChipList && (
              <GridComponent sx={{ mt: 1 }}>
                <Stack direction="row" spacing={1} className="upload-doc-chip">
                  <div>{props.docsChipList}</div>
                </Stack>
              </GridComponent>
            )}
            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="text"
                    href="#contained-buttons"
                    onClick={handleDialogBoxOpen}
                    disabled={isSubmitDisabled()}
                  >
                    Cancel
                  </Button>
                  <PopupComponent
                    open={enable}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    child
                  >
                    <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Are you sure you want to cancel uploading this document?
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={props.clearData} autoFocus className='grey-btn'>
                        Yes
                      </Button>
                      <Button onClick={handleDialogBoxClose}>No</Button>
                    </DialogActions>
                  </PopupComponent>
                  <Button
                    variant="text"
                    href="#contained-buttons"
                    onClick={_ => handleUploadDocument()}
                    disabled={!dfile || !props.uploadDocPermission || isSubmitDisabled()}
                  >
                    Submit
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
